module.exports = __webpack_public_path__ + "static/media/carif.f2aa9e45.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/images/Logos_Lieferanten/carif.png
// module id = 399
// module chunks = 0